"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Text_1 = __importDefault(require("../Text"));
const Image_1 = __importDefault(require("../Image"));
const Container = styled_1.default.div({
    display: 'inline-block',
});
const Caption = (0, styled_1.default)(Text_1.default)({
    marginTop: 4,
});
function Card({ className, imageClassName, imageUrl, title, centeredTitle, roundImage, }) {
    return (react_1.default.createElement(Container, { className: className },
        imageUrl && (react_1.default.createElement(Image_1.default, { className: imageClassName, circular: roundImage, src: imageUrl })),
        react_1.default.createElement(Caption, { variant: "subtitle", textAlign: centeredTitle ? 'center' : undefined }, title)));
}
exports.default = Card;
